export default "__VITE_ASSET__D32AP84J__"